import { useState, useMemo, useEffect } from "react";
export const useLocationState = ({ initialState = [] }) => {
  const [stateVal, setStateVal] = useState(initialState);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return { currentState, previousState, setStateVal };
  }, [stateVal]);

  return { currentState, previousState, setStateVal };
};
export const useReceiveExternalMessages = (
  setStateVal,
  setExternalMode,
  handleMessageCallback = () => {},
) => {
  const handleMessage = (event) => {
    const { type, data, message = "" } = event.data;
    if (type === "set-params" && !message) {
      setStateVal(data);
      setExternalMode(true);
      handleMessageCallback?.(data);
    }

    if (message === "navigate-to-ai-new-program") {
      handleMessageCallback?.(event.data, message);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
};
